import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { WidgetsModule } from '../../widgets/widgets.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { SupportRoutingModule } from './support-routing.module';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { CoveragesComponent } from './coverages/coverages.component';
import { MapNavigatorComponent } from './coverages/components/map-navigator/map-navigator.component';
import { MapToolbarComponent } from './coverages/components/map-toolbar/map-toolbar.component';
import { DealersComponent } from './dealers/dealers.component';
import { FreeupTalkComponent } from './freeup-talk/freeup-talk.component';
import { HearingAidCompatibilityComponent } from './hearing-aid-compatibility/hearing-aid-compatibility.component';
import { InternationalSmsComponent } from './international-sms/international-sms.component';
import { DataSetupComponent } from './data-setup/data-setup.component';
import { SitemapComponent } from './sitemap/sitemap.component';
import { StoreLocatorComponent } from './store-locator/store-locator.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { SupportMainComponent } from './support.component';
import { FaqsComponent } from './faqs/faqs.component';
import { LandingCoverageComponent } from './landing-coverage/landing-coverage.component';
import { SwitchAndSaveComponent } from './switch-and-save/switch-and-save.component';
import { HdVoiceComponent } from './hd-voice/hd-voice.component';
import { WifiCallingPageComponent } from './wifi-calling-page/wifi-calling-page.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AndroidTmoComponent } from './data-setup/android/tmo/tmo.component';
import { AndroidAttComponent } from './data-setup/android/att/att.component';
import { AndroidFourthGenerationPageComponent } from './data-setup/android/att/fourth-generation-page/fourth-generation-page.component';
import { AndroidFifthGenerationPageComponent } from './data-setup/android/att/fifth-generation-page/fifth-generation-page.component';
import { SupportComponent } from './faqs/support/support.component';
import { IosAttComponent } from './data-setup/ios/att/att.component';
import { IosTmoComponent } from './data-setup/ios/tmo/tmo.component';
import { IosFourthGenerationPageComponent } from './data-setup/ios/att/fourth-generation-page/fourth-generation-page.component';
import { IosFifthGenerationPageComponent } from './data-setup/ios/att/fifth-generation-page/fifth-generation-page.component';
import { DataSetupCommonContentComponent } from './data-setup/data-setup-common-content/data-setup-common-content.component';

@NgModule({
  declarations: [ContactUsComponent, CoveragesComponent, MapNavigatorComponent, MapToolbarComponent,
    DealersComponent, FreeupTalkComponent, HearingAidCompatibilityComponent, InternationalSmsComponent,
    DataSetupComponent,
    SitemapComponent, TermsAndConditionsComponent,
    StoreLocatorComponent, SupportMainComponent, FaqsComponent, LandingCoverageComponent, SwitchAndSaveComponent,
    HdVoiceComponent, WifiCallingPageComponent, AndroidTmoComponent,
    AndroidAttComponent, AndroidFourthGenerationPageComponent, AndroidFifthGenerationPageComponent, SupportComponent,
    IosAttComponent, IosTmoComponent, IosFourthGenerationPageComponent, IosFifthGenerationPageComponent, DataSetupCommonContentComponent],
  imports: [
    CommonModule,
    SupportRoutingModule,
    WidgetsModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    MatAutocompleteModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SupportModule { }
